import React, { type FunctionComponent } from 'react'
import { type RetailerScopedRouteParams } from '../../../../legacy/common/types'
import { type DashRouteComponentProps } from '../../../../legacy/dash-components/dash-route/utils/dashRoute.types'
import WarehouseProvider from '../../../../utils/contexts/warehouse/WarehouseProvider'
import { RetailerScopedRoutes } from './RetailerScopedRoutes'

interface Props extends DashRouteComponentProps<RetailerScopedRouteParams> {}

export const RetailerScopedSection: FunctionComponent<React.PropsWithChildren<Props>> = ({
  match: {
    params: { warehouse_id: warehouseId },
  },
}) => (
  <>
    <WarehouseProvider id={warehouseId}>
      <RetailerScopedRoutes />
    </WarehouseProvider>
  </>
)
